import { render, staticRenderFns } from "./BxKuncunList.vue?vue&type=template&id=7d5d523a&scoped=true&"
import script from "./BxKuncunList.vue?vue&type=script&lang=js&"
export * from "./BxKuncunList.vue?vue&type=script&lang=js&"
import style0 from "./BxKuncunList.vue?vue&type=style&index=0&id=7d5d523a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5d523a",
  null
  
)

export default component.exports